export function isValidNpiChecksum(npi: string): boolean {
  if (!/^\d{10}$/.test(npi)) {
    return false;
  }

  const digits = `80840${npi.slice(0, 9)}`.split('').map(Number);
  let sum = 0;

  digits.forEach((digit, index) => {
    let value = digit;
    if (index % 2 === 1) {
      value *= 2;
      if (value > 9) {
        value -= 9;
      }
    }
    sum += value;
  });

  const expectedCheckDigit = (10 - (sum % 10)) % 10;
  return expectedCheckDigit === Number(npi[9]);
}
